import types from '../types';

const orders = (
  state = {
    data: null,
    loading: false,
  },
  { type, payload },
) => {
  switch (type) {
    case types.GET_ORDERS_START:
      return { ...state, loading: true };

    case types.GET_ORDERS_SUCCESS:
      return { data: payload, loading: false };

    case types.GET_ORDERS_FAILURE:
      return { data: {}, loading: false };

    default:
      return state;
  }
};

export default orders;
